module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRowWhite",
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(30)
      }
    }
  }, [_vm._v("最近30天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "disabled": _vm.loading
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportIncome
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t\t\t 平台来源：  \n\t\t\t\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源",
      "clearable": ""
    },
    on: {
      "change": _vm.changePlatform
    },
    model: {
      value: (_vm.pdata.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "platform_id", $$v)
      },
      expression: "pdata.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-option', {
      key: v.platform_id,
      attrs: {
        "label": v.platform_name,
        "value": v.platform_id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height,
      "element-loading-text": "拼命加载中",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(0, 0, 0, 0.3)",
      "header-cell-class-name": _vm.getHeaderCellClassName,
      "cell-class-name": _vm.cellClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "发行名称",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "虚拟结算",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "huanliang_in",
      "label": "换入量",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.huanliang_in - 0) - (b.huanliang_in - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "量级*单价",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("换入量")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.huanliang_in) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "huanliang_out",
      "label": "换出量",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.huanliang_out - 0) - (b.huanliang_out - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "量级*单价",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("换出量")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.huanliang_out) + "\n\t\t\t      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "matrix_buy_cost",
      "label": "矩阵买量",
      "align": "center",
      "min-width": "110px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.matrix_buy_cost - 0) - (b.matrix_buy_cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.matrix_buy_cost) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "matrix_sell_income",
      "label": "矩阵卖量",
      "align": "center",
      "min-width": "110px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.matrix_sell_income - 0) - (b.matrix_sell_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.matrix_sell_income) + "\n\t\t\t    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "现金结算",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "origin_income",
      "label": "流量主",
      "align": "center",
      "min-width": "90px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.origin_income - 0) - (b.origin_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.origin_income) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_divide_income",
      "label": "流量主分成后",
      "align": "center",
      "min-width": "160px",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.origin_divide_income - 0) - (b.origin_divide_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.origin_divide_income) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "channel_sell_income",
      "label": "渠道卖量",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.channel_sell_income - 0) - (b.channel_sell_income - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.channel_sell_income) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "channel_buy_cost",
      "label": "渠道买量",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.channel_buy_cost - 0) - (b.channel_buy_cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.channel_buy_cost) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gdt_buy_cost",
      "label": "广点通",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.gdt_buy_cost - 0) - (b.gdt_buy_cost - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.gdt_buy_cost) + "\n\t\t\t    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "合计（含矩阵）",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "total_income_contain_matrix",
      "label": "收入",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_income_contain_matrix - 0) - (b.total_income_contain_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_income_contain_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_cost_contain_matrix",
      "label": "成本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_cost_contain_matrix - 0) - (b.total_cost_contain_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "成本日报-实际花费",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("成本")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_cost_contain_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_profit_contain_matrix",
      "label": "利润",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_profit_contain_matrix - 0) - (b.total_profit_contain_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "收入合计-买量成本",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("利润")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t      \t￥"), _c('span', {
          class: scope.row.total_profit_contain_matrix > 0 ? '' : 'red'
        }, [_vm._v(_vm._s(scope.row.total_profit_contain_matrix))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "合计（不含矩阵）",
      "align": "center"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "total_income_no_matrix",
      "label": "收入",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_income_no_matrix - 0) - (b.total_income_no_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_income_no_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_cost_no_matrix",
      "label": "成本",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_cost_no_matrix - 0) - (b.total_cost_no_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "成本日报-实际花费",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("成本")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t       \t\t￥" + _vm._s(scope.row.total_cost_no_matrix) + "\n\t\t\t    ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_profit_no_matrix",
      "label": "利润",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.total_profit_no_matrix - 0) - (b.total_profit_no_matrix - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "收入合计-买量成本",
            "placement": "top-start"
          }
        }, [_c('span', [_vm._v("利润")])])]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t      \t￥"), _c('span', {
          class: scope.row.total_profit_no_matrix >= 0 ? '' : 'red'
        }, [_vm._v(_vm._s(scope.row.total_profit_no_matrix))])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出选择",
      "visible": _vm.checkDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.checkDialog = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleDownload
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3f90a18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/income/incomeDailyDetail.vue
// module id = 1149
// module chunks = 2